/* import __COLOCATED_TEMPLATE__ from './primary-inbox-cell.hbs'; */
/* RESPONSIBLE TEAM: team-email */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-component-inheritance */

import InviteBaseCell from 'embercom/components/table-cells/invite-list/base-cell';

export default class PrimaryInboxCell extends InviteBaseCell {
  get inviteConfiguration() {
    return this.row.advancedInviteConfiguration;
  }

  get primaryTeams() {
    return this.inviteConfiguration ? this.inviteConfiguration.primaryTeams : '-';
  }
}
